import dayjs, { type Dayjs } from 'dayjs';
import { isNil } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import DayjsRangePicker from '../../components/DayjsRangePicker';
import { type RangePickerFieldProps } from '../../components/fields/RangePickerField';
import CalendarIcon from '../../icons/mobility/calendar.svg';
import { RangePickerCss } from '../porsche/RangePicker';
import { RangePickerContainer } from './Fields/shared';

const StyledRangePicker = styled(DayjsRangePicker)`
    ${RangePickerCss}
`;

type RangePickerOnChangeHandler = (period: [Dayjs, Dayjs] | undefined) => unknown;

const RangePicker = ({ onChange, value, disabled, ...props }: RangePickerFieldProps) => {
    const [datePickerValue, setDatePickerValue] = useState<[Dayjs, Dayjs]>();

    useEffect(() => {
        if (value) {
            setDatePickerValue(value);
        }
    }, [value]);

    const onEnhancedChange = useCallback<RangePickerOnChangeHandler>(
        period => {
            if (period) {
                const [start, end] = period;

                // update formik values
                setDatePickerValue([!isNil(start) ? dayjs(start) : undefined, !isNil(end) ? dayjs(end) : undefined]);

                if (onChange) {
                    onChange(period, [dayjs(period[0]).toISOString(), dayjs(period[1]).toISOString()]);
                }

                return;
            }

            setDatePickerValue(undefined);
        },
        [onChange]
    );

    return (
        <RangePickerContainer disabled={Array.isArray(disabled) ? disabled.some(Boolean) : disabled}>
            <StyledRangePicker
                {...props}
                disabled={disabled}
                onChange={onEnhancedChange}
                suffixIcon={<CalendarIcon />}
                value={datePickerValue}
            />
        </RangePickerContainer>
    );
};

export default RangePicker;
